import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const FieldTextArea = ({
  id,
  value,
  handleChange,
  onClick,
  placeholder,
  readOnly,
  required,
  styles,
  rows = 4,
}) => {
  return (
    <S.Container type="textarea" styles={styles}>
      <S.InputContainer>
        <S.InputWrapper className={!readOnly ? "visible" : "hidden"}>
          <S.TextArea
            name={id}
            value={value}
            onChange={(e) => handleChange(id, e.target.value)}
            placeholder={placeholder}
            readOnly={readOnly}
            required={required}
            styles={styles}
            onClick={onClick}
            rows={rows}
          />
        </S.InputWrapper>
        <S.Text className={!readOnly ? "hidden" : "visible"}>{value}</S.Text>
      </S.InputContainer>
    </S.Container>
  );
};

FieldTextArea.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  styles: PropTypes.string,
  onClick: PropTypes.func,
  rows: PropTypes.number,
};
